/*
 * Copyright Mimic Networks, Inc. 2024.
 */

import { TagOutlined } from '@ant-design/icons';

export function TagIcon() {
  return <TagOutlined />;
}
